import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import { AppRemixIcon, AppCheckbox, AppSingleSelect } from "@/layout/AppComponents";
import { UnmountClosed } from "react-collapse/lib/UnmountClosed";
import { useSelector } from "react-redux";
import ReactDOMServer from "react-dom/server";
import styled from "styled-components";
import Translator from "../../../components/helpers/Translator";

export default function UserManagementModuleCard({ module, values, setFieldValue }) {
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const modulePermissions = useSelector(
    (s) => s.module[moduleBridgeHex]?.permissions?.userManagement,
  );
  const templateOptions = useSelector((s) => s.currentPage?.permissionTemplates);
  const renderPermissionSelect = useCallback(() => {
    switch (module?.type) {
      case "DocumentManager":
      case "TotalEnergiesRisk":
        return (
          <div style={{ marginLeft: "auto", minWidth: "300px" }}>
            <AppSingleSelect
              title="Nivel de permiso"
              options={module?.permissionsLevels}
              placeholder={module?.permissionsLevels?.[0]?.label}
              value={values?.modules?.[module.hex]?.permissionLevel}
              onChange={(opt) =>
                setFieldValue(`modules[${module.hex}].permissionLevel`, opt)
              }
            />
          </div>
        );
      case "LegalCompliance":
        return (
          <>
            {templateOptions?.length > 0 && modulePermissions?.permissionTemplates &&
              modulePermissions?.permissionTemplates !== false && (
                <PermissionTemplateWrapper>
                  <AppSingleSelect
                    icon={<AppRemixIcon icon="apps-2" />}
                    options={templateOptions || []}
                    title={ReactDOMServer.renderToString(
                      <Translator file="admin" name="general.permission.templates" />,
                    )}
                    value={values?.template ? null : values?.modules?.[module.hex]?.template}
                    onChange={(opt) =>
                      setFieldValue(`modules[${module.hex}].template`, opt)
                    }
                    isClearable
                    isDisabled={values?.template}
                  />
                </PermissionTemplateWrapper>
              )}
          </>
        );
      default:
        return null;
    }
  }, [module, values, setFieldValue, modulePermissions, templateOptions]);

  return (
    <>
      <div className="card border mt-2">
        <div
          className={`${
            module.type === "LegalCompliance" ? "bg-light text-white" : ""
          }`}
        >
          <div className="ml-2 mr-2 d-flex align-items-center">
            <AppCheckbox
              value={values?.modules?.[module.hex]}
              onChange={(v) =>
                setFieldValue(
                  `modules[${module.hex}]`,
                  values?.modules?.[module.hex] ? undefined : {},
                )
              }
            />

            <img
              src={module.image !== null ? module.image : auth.user.client.logoUrl}
              // src="https://worldlex.net/assets/images/modules/cards/gcl.png"
              className="img-responsive"
              style={{ height: "30px" }}
            />

            <h3 className="ml-2 mt-2">{module.name}</h3>
            {renderPermissionSelect()}
          </div>
          {values?.modules?.[module.hex] && module.plants && (
            <div className="float-right mt-3 mr-3">
              <span
                className="mr-2 pointer text-primary"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-userManagement"
                    name="module.um.select-all-installations"
                  />,
                )}
                onClick={() =>
                  module.plants?.map((p) =>
                    setFieldValue(`modules[${module.hex}].plants.${p.hex}`, true),
                  )
                }
              >
                <AppRemixIcon icon="checkbox" size={20} />
              </span>

              <span
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-userManagement"
                    name="module.um.unselect-all-installations"
                  />,
                )}
                className="mr-2 pointer text-primary"
                onClick={() =>
                  setFieldValue(`modules[${module.hex}].plants`, undefined)
                }
              >
                <AppRemixIcon icon="checkbox-blank" size={20} />
              </span>
            </div>
          )}

          <UnmountClosed isOpened={!!values?.modules?.[module.hex] && module.plants}>
            {module.plants?.map((plant) => (
              <div className="p-1 ml-4 mr-4" key={plant.hex}>
                <div className="bg-white">
                  <div className="d-inline-flex align-items-center p-1">
                    <AppCheckbox
                      value={values?.modules?.[module.hex]?.plants?.[plant.hex]}
                      onChange={(v) =>
                        setFieldValue(`modules[${module.hex}].plants.${plant.hex}`, v)
                      }
                    />
                    {/* <span className="btn-group">
                      <img
                        src={
                          plant.image
                            ? plant.image
                            : 'https://worldlex.net/assets/images/modules/cards/gcl.png'
                        }
                        // src="https://worldlex.net/assets/images/modules/cards/gcl.png"
                        className="img-responsive"
                        style={{ height: '30px' }}
                      />
                    </span> */}
                    <span className="ml-2">
                      <h3 className="mt-2">{plant.name}</h3>
                    </span>
                  </div>
                </div>
              </div>
            ))}

            <div className="p-1 ml-4 mr-4">
              <div style={{ backgroundColor: "#fff3cd" }} className="text-primary">
                <div className="d-inline-flex align-items-center p-1">
                  <AppCheckbox
                    value={values?.modules?.[module.hex]?.emailNotification}
                    onChange={(v) =>
                      setFieldValue(`modules[${module.hex}].emailNotification`, v)
                    }
                  >
                    <h3 className="ml-2 mt-2">
                      <Translator
                        file="module-userManagement"
                        name="module.um.notification-obligations-email"
                      />
                    </h3>
                  </AppCheckbox>
                </div>
              </div>
            </div>
          </UnmountClosed>
        </div>
      </div>
    </>
  );
}

const PermissionTemplateWrapper = styled.div`
  margin-left: auto;
  margin-right: 20px;
  padding: 0 10px;
  min-width: 400px;
  background-color: white;
  color: #212529;
`;
